export default __webpack_public_path__ + "static/media/redArrow3.ea0d5a26.webp";